import React, { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CatalogPage } from "./routes/index";
import { initAnalytics, trackPageView } from "./lib/analytics";
import "./styles.css";

// Só o catálogo entra no bundle inicial. As demais páginas viram chunks à parte:
// carregar o código do painel de admin junto com a home atrasava a primeira
// pintura (78% do LCP era espera de execução de JS).
const PrivacyPolicyPage = lazy(() =>
  import("./pages/PrivacyPolicyPage").then((m) => ({ default: m.PrivacyPolicyPage })),
);
const TikTokReviewDemoPage = lazy(() =>
  import("./pages/TikTokReviewDemoPage").then((m) => ({ default: m.TikTokReviewDemoPage })),
);
const TermsOfServicePage = lazy(() =>
  import("./pages/TermsOfServicePage").then((m) => ({ default: m.TermsOfServicePage })),
);
const CouponsPage = lazy(() =>
  import("./pages/CouponsPage").then((m) => ({ default: m.CouponsPage })),
);
const ManageCouponsPage = lazy(() =>
  import("./pages/ManageCouponsPage").then((m) => ({ default: m.ManageCouponsPage })),
);
const ManageStoresPage = lazy(() =>
  import("./pages/ManageStoresPage").then((m) => ({ default: m.ManageStoresPage })),
);
const ManagePlatformsPage = lazy(() =>
  import("./pages/ManagePlatformsPage").then((m) => ({ default: m.ManagePlatformsPage })),
);
const ExtractMLPage = lazy(() =>
  import("./pages/ExtractMLPage").then((m) => ({ default: m.ExtractMLPage })),
);
const ManageQueuePage = lazy(() =>
  import("./pages/ManageQueuePage").then((m) => ({ default: m.ManageQueuePage })),
);

const queryClient = new QueryClient();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Missing #root element for storage build");
}

initAnalytics();
trackPageView("Achados do Dia");

createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<PageLoading />}>
        <StorageEntry />
      </Suspense>
    </QueryClientProvider>
  </React.StrictMode>,
);

function PageLoading() {
  return (
    <div className="grid min-h-screen place-items-center text-sm text-muted-foreground">
      Carregando...
    </div>
  );
}

function StorageEntry() {
  const pathname = window.location.pathname.replace(/\/+$/, "") || "/";

  // Aceita tanto as URLs em português quanto os aliases em inglês (para revisores do TikTok, etc.)
  if (pathname === "/politica-de-privacidade" || pathname === "/privacy-policy") {
    return <PrivacyPolicyPage />;
  }

  if (pathname === "/tiktok-review-demo") {
    return <TikTokReviewDemoPage />;
  }

  if (pathname === "/termos-de-servico" || pathname === "/terms-of-service") {
    return <TermsOfServicePage />;
  }

  if (pathname === "/cupons" || pathname === "/coupons") {
    return <CouponsPage />;
  }

  if (pathname === "/gerenciar-cupons" || pathname === "/admin/cupons") {
    return <ManageCouponsPage />;
  }

  if (pathname === "/gerenciar-lojas" || pathname === "/admin/lojas") {
    return <ManageStoresPage />;
  }

  if (pathname === "/gerenciar-plataformas" || pathname === "/admin/plataformas") {
    return <ManagePlatformsPage />;
  }

  if (pathname === "/extrair-ml" || pathname === "/admin/extrair-ml") {
    return <ExtractMLPage />;
  }

  if (pathname === "/gerenciar-fila" || pathname === "/admin/fila") {
    return <ManageQueuePage />;
  }

  return <CatalogPage />;
}
